import React from 'react';
import { useUsernameSelection } from '../../hooks/useUsernameSelection';
import './UsernameModal.css';

const UsernameModal = ({ onSuccess }) => {
  const {
    usernameInput,
    usernameError,
    usernameLoading,
    usernameAvailable,
    checkingAvailability,
    handleUsernameChange,
    submitUsername
  } = useUsernameSelection(onSuccess);

  const isSubmitDisabled =
    !usernameInput ||
    usernameLoading ||
    usernameAvailable === false ||
    !!usernameError;

  return (
    <>
      <div className="modal-overlay" />
      <div className="username-modal">
        <h3>Welcome! Choose Your Username</h3>
        <p className="modal-subtitle">
          This will be your unique identifier in the app
        </p>

        <input
          type="text"
          value={usernameInput}
          onChange={handleUsernameChange}
          placeholder="Enter username"
          maxLength={20}
          className={`username-input ${usernameError ? 'error' : ''}`}
        />

        {usernameInput && !usernameError && (
          <div className={`availability-indicator ${
            usernameAvailable === true ? 'available' : 
            usernameAvailable === false ? 'taken' : ''
          }`}>
            {checkingAvailability && 'Checking availability...'}
            {usernameAvailable === true && '✓ Username is available'}
            {usernameAvailable === false && '✗ Username is already taken'}
          </div>
        )}

        {usernameError && (
          <div className="error-message">{usernameError}</div>
        )}

        <button
          onClick={submitUsername}
          disabled={isSubmitDisabled}
          className="btn-submit-username"
        >
          {usernameLoading ? 'Setting Username...' : 'Set Username'}
        </button>

        <p className="username-requirements">
          3-20 characters, letters, numbers, underscore, and dash only
        </p>
      </div>
    </>
  );
};

export default UsernameModal;